<template>
  <div class="footer-links-container">
      <div class="footer-social-links">
        <div class ="footer-social-account">
          <a class="facebook-icon" aria-label="Youpaired's facebook" href="https://www.facebook.com/youpaired/">
            <font-awesome-icon :icon="['fab', 'facebook-square']"/>
          </a>
          <a class="linkedin-icon" aria-label="Youpaired's LinkedIn" href="https://www.linkedin.com/company/youpaired">
            <font-awesome-icon :icon="['fab', 'linkedin']"/>
          </a>
          <a class="twitter-icon"  aria-label="Youpaired's Twitter" href="https://twitter.com/youpaired">
            <font-awesome-icon :icon="['fab', 'twitter-square']"/>
          </a>
          <a class="instagram-icon" aria-label="Youpaired's Instagram" href="https://www.instagram.com/youpaired">
            <font-awesome-icon :icon="['fab', 'instagram']"/>
          </a>
        </div>
      </div>
      <div
        v-for="({ url, title }, i) in links"
        :key="i"
        class="link-container">
        <div class="footer-button">
          <div class="footer-content">
            <span class="link" v-if="typeof url === 'function'" @click="url()">{{title}}</span>
            <a v-else
              :href="url"
              target="_blank"
              class="link">{{ title }}</a>
          </div>
        </div>
      </div>
      <div class="youpaired-copyright">
        © 2019 — YouPaired
      </div>
      <h3 class="youpaired-copyright">
      We<span>♥️</span>Events.
      </h3>
  </div>
</template>

<script>
export default {
  name: 'YoupairedFooter',
  data() {
    return {
      links: [
        {
          url: `${process.env.VUE_APP_URL}/privacy`,
          title: 'PRIVACY',
        }, {
          url: `${process.env.VUE_APP_URL}/terms`,
          title: 'TERMS',
        }, {
          url: `${process.env.VUE_APP_URL}/cookies`,
          title: 'COOKIE',
        }, {
          url: `${process.env.VUE_APP_HELP_URL}`,
          title: 'HELP CENTER',
        }, {
          url: process.env.VUE_APP_BLOG_URL,
          title: 'BLOG',
        }, {
          url: this.showSupport,
          title: 'CONTACT US',
        },
      ],
    };
  },
  methods: {
    showSupport() {
      window.zE('webWidget', 'show');
      window.zE('webWidget', 'open');
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/youpaired-colors.scss";

.footer-links-container {
  position: relative;
  padding: 2rem 0 1rem;
  background-image: radial-gradient(circle farthest-corner at 12.3% 19.3%, #2f2f2f 0, #333 100.2%);
  color: #fff;
  text-align: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  flex-wrap: wrap;
}

.footer-content {
  margin: 1rem;
  cursor: pointer;
  justify-content: start;
}

.link {
  color: white;
  text-decoration: none;
  cursor: pointer;
  &:hover {
    text-decoration: underline;
  }
}
.youpaired-copyright {
  color: white;
  display: flex;
  flex-basis: 100%;
  justify-content: center;
  margin: 1rem 0;
}

.footer-social-links {
  display: flex;
  flex-basis: 100%;
  justify-content: center;
  margin: 1rem 0;
  cursor: pointer;
}

.facebook-icon, .linkedin-icon, .twitter-icon, .instagram-icon {
  color: white;
  margin: 1rem;
  font-size: 1.5rem;
    &:hover {
    color: $login-hover;
  }
}
.youpaired-copyright span {
    margin: -3px 7px;
}

@media screen and (max-width: 411px) {
  .footer-links-container {
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  }

  .footer-content {
  margin: 0.25rem;
}
}

</style>
